import { AxiosResponse } from "axios"
import { ConfigurableFormPackageProcessor } from "../../DTOtemp"
import SecureClient from "../SecureClient"

export class FormPackageProcessorsClient extends SecureClient {

	private _urlBase: string

	constructor() {
		super()
		this._urlBase = `FormPackageProcessors`
	}

	public getFormPackageProcessors(): Promise<AxiosResponse<ConfigurableFormPackageProcessor[]>> {
		return this._api.get<ConfigurableFormPackageProcessor[]>(this._urlBase, {
			headers: {
				...this.authorizationHeader,
				...this.acceptHeader(),
			},
		})
	}

	public getFormPackageProcessor(processorId: string): Promise<AxiosResponse<ConfigurableFormPackageProcessor>> {
		return this._api.get<ConfigurableFormPackageProcessor>(`${this._urlBase}/${processorId}`, {
			headers: {
				...this.authorizationHeader,
				...this.acceptHeader()
			}
		})
	}

}